<template>
  <smd-one-col-layout>
    <smd-header slot="header"
                :nav="$isDesktop">
      <smd-btn class="back-btn"
                icon="ns-icon-ico028"
                slot="left-actions"
                @click="closeModal"/>
      <h2 class="Title1 educ-header">
        {{content.title}}
      </h2>
    </smd-header>

    <div class="educ-content-page">

      <div class="educ-content-page__title-author">
        <p class="Title1">{{content.title}}</p>

        <div class="author">
          <smd-profile-img-placeholder size="s" :text="content.author" />
          <p class="Body3 gray-400">
            {{content.author}}
            <span class="Body4">{{formatDateShared}}</span>
          </p>
        </div>

        <div v-if="tags"
             class="tags-container">
          <div v-for="(tag, index) in tags"
              :key="index"
              class="tag">
            <p>{{tag}}</p>
          </div>
        </div>
      </div>

      <div v-if="content.coverurl"
           class="educ-content-page__cover">
        <img :src="content.coverurl" :alt="content.title">
      </div>

      <smd-loading-spinner v-if="!htmlContent"></smd-loading-spinner>
      <div v-if="htmlContent" v-html="htmlContent"></div>
      <p v-if="error" class="Body4 text-center crimson">{{error}}</p>
      <smd-btn v-if="error"
               section="4"
               variant="blue-enabled"
               class="align-self-center"
               @click="tryAgain">
        Try again
      </smd-btn>

    </div>
  </smd-one-col-layout>
</template>

<script>
  import moment from 'moment';

  import {EducationService} from '@/services/education';

  import CloseModalMixin from '@/mixins/close-modal-mixin';

  export default {
    name: 'educ-content-page',
    mixins: [CloseModalMixin],
    props: {
      content: {type: Object, required: true},
      token: {type: String, required: true},
      metadata: {type: Object},
    },
    data() {
      return {
        htmlContent: null,
        error: null,
      }
    },
    computed: {
      formatDateShared() {
        return moment(this.content.dateshared).format('MM/DD/YYYY');
      },
      tags() {
        return this.metadata && this.metadata.tags ? this.metadata.tags : [];
      },
    },
    mounted() {
      this.getHtmlContent();
    },
    methods: {
      async getHtmlContent() {
        try {
          const {data} = await EducationService.getHTMLOutputPxMaterial(this.content.msgid, this.token);
          await EducationService.sendAnalytics(this.content.doctorid, this.content.materialid, this.content.token);

          if (data && data.result !== -9) {
            this.htmlContent = data;
          } else {
            throw Error();
          }

        } catch (error) {
          console.error(error);
          this.error = "An unexpected error occured while loading content."
        }
      },
      tryAgain() {
        this.error = null;
        this.getHtmlContent();
      },
    },
  }
</script>

<style lang="scss" scoped>
  .educ-header {
    @extend %text-overflow-ellipsis;
    display: -webkit-box;
    white-space: normal;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }

  .educ-content-page {
    @include flex-col();
    gap: 20px;

    &__title-author {
      @include flex-col();
      gap: 10px;

      .author {
        @extend %layout--flex-row-center-x;
        gap: 18px;

        span {
          display: block;
        }
      }

      .tags-container {
        @include flex-row(true, wrap);
        gap: space(xs);

        .tag {
          width: max-content;
          padding: 4px 8px;
          background-color: #2A2B6C;
          color: color(white);
          border-radius: 4px;

          p {
            font-size: font(s)+2;
            font-weight: 700;
            text-transform: uppercase;
          }
        }
      }
    }

    &__cover {
      overflow: hidden;

      img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    }

  }
</style>
